





















































import { Component, Vue } from "vue-property-decorator";
import { UserCustomer } from "@/model/user";
import QErrors from "@/common/qErrors.vue";
import qNotify from "../../../common/qNotify";

@Component({
  name: "ChangePassword",
  components: {
    QErrors,
  },
})
export default class ChangePassword extends Vue {
  private isShow = false;
  private customer = new UserCustomer();
  private errors = {};

  public async submit() {
    this.customer.changePassword().then(
      () => {
        qNotify.success({
          text: this.$t("my_page.changed_password.updated"),
        });
        this.isShow = false;
      },
      (error) => {
        this.errors = error.meta.errors;
      }
    );
  }

  public cancel() {
    this.isShow = false;
  }

  public show() {
    this.customer = new UserCustomer();
    this.errors = {};
    this.isShow = true;
  }
}
